export enum FormElementValidationType {
  NoValidation = 0,
  OnlyNumbers = 1,
  Email = 2,
  NumberOfCharacters = 3,
}
